import { c as _c } from "react-compiler-runtime";
import { useCallback, useRef } from 'react';
import { useObserveTableContainerRef } from '../../virtualization/hooks/useObserveTableContainerRef';
import { useResetTableState } from './useResetTableState';
export const useWatchTableContainer = t0 => {
  const $ = _c(12);
  const {
    rowIds,
    disableScrollReset: t1,
    scrollContainerRef
  } = t0;
  const disableScrollReset = t1 === undefined ? false : t1;
  const {
    handleObserveRef,
    observer
  } = useObserveTableContainerRef();
  const tableContainerRef = useRef(null);
  let t2;
  if ($[0] !== handleObserveRef || $[1] !== scrollContainerRef) {
    t2 = ref => {
      handleObserveRef(ref);
      tableContainerRef.current = ref;
      if (scrollContainerRef) {
        scrollContainerRef.current = ref;
      }
    };
    $[0] = handleObserveRef;
    $[1] = scrollContainerRef;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleTableContainerRef = t2;
  let t3;
  if ($[3] !== handleObserveRef) {
    t3 = () => handleObserveRef(tableContainerRef.current);
    $[3] = handleObserveRef;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const resetObserver = t3;
  let t4;
  if ($[5] !== disableScrollReset || $[6] !== resetObserver || $[7] !== rowIds) {
    t4 = {
      rowIds,
      tableContainerRef,
      resetObserver,
      disableScrollReset
    };
    $[5] = disableScrollReset;
    $[6] = resetObserver;
    $[7] = rowIds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useResetTableState(t4);
  let t5;
  if ($[9] !== handleTableContainerRef || $[10] !== observer) {
    t5 = {
      observer,
      handleTableContainerRef
    };
    $[9] = handleTableContainerRef;
    $[10] = observer;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};